import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import * as myGlobals from 'src/app/globals';
import { ShareManagementResponseModal, ShareManagementSendModal } from 'src/app/models/modal.model';
import { HttpResponseModel } from 'src/app/models/response.model';
@Injectable()
export class ShareManagementModalService {
  constructor(private http: HttpClient) {}

  getSharesList(objectId: string): Observable<HttpResponseModel<ShareManagementResponseModal[]>> {
    const url = `${myGlobals.Config.API}/shares/${objectId}/private?page=0&size=1000&sortField=shareDate&sortDirection=Descending`;

    return this.http.get<HttpResponseModel<ShareManagementResponseModal[]>>(url);
  }

  sendRemovedAndChangedList(requestBody: ShareManagementSendModal): Observable<ShareManagementResponseModal[]> {
    return this.http.put<ShareManagementResponseModal[]>(`${myGlobals.Config.API}/shares`, requestBody);
  }

  getSharesListForBulkShare(objectId: string): Observable<HttpResponseModel<ShareManagementResponseModal[]>> {
    return this.http.get<HttpResponseModel<ShareManagementResponseModal[]>>(
      `${myGlobals.Config.API}/shares/${objectId}?page=0&size=100&sortField=shareDate&sortDirection=Descending`,
    );
  }
}
